import { render, staticRenderFns } from "./AdShopProduct.vue?vue&type=template&id=f1f14a84&"
import script from "./AdShopProduct.vue?vue&type=script&lang=js&"
export * from "./AdShopProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports